const layout = {
  sideBar: {
    menu: {
      more: {
        children: {
          suppliers: 'ציים',
        },
      },
    },
  },
};

export default layout;